module.exports = __webpack_public_path__ + "static/img/report_img_ydylyxgjaq.f655626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_ydylyxgjaq.png
// module id = UTEG
// module chunks = 21